import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../images/Logo_Mozart_color.png';
import { useDataUser } from '../../context/dataUserContext';

const Header = ({ setActiveComponent }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const { setIsAuth } = useDataUser();
  const navigate = useNavigate();

  const role = localStorage.getItem('role');

  const handleLogout = () => {
    localStorage.clear();
    setIsAuth(false); //Para limpiar el contexto
    navigate('/');
  };
  useEffect(() => {
    setActiveComponent('clinica');
  }, [setActiveComponent]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Saludo dinámico según el rol y nombre completo
  let userName = '';
  if (role === 'doctor') {
    userName = localStorage.getItem('doctorName');
  } else if (role === 'patient') {
    userName = localStorage.getItem('patientName');
  } else if (role === 'admin') {
    userName = localStorage.getItem('adminName');
  } else if (role === 'clinic') {
    userName = localStorage.getItem('clinicName');
  }
  let saludo = 'Bienvenido a Redplika';
  const roleNormalized = (role || '').toLowerCase().trim();
  if (roleNormalized === 'doctor') saludo = 'Bienvenido Doctor';
  else if (roleNormalized === 'patient') saludo = 'Bienvenido Paciente';
  else if (roleNormalized === 'admin') saludo = 'Bienvenido Administrador';
  else if (roleNormalized === 'clinic') saludo = 'Bienvenido/a Clínica';

  return (
    <header className="bg-white border-b border-slate-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex flex-col md:flex-row justify-between items-center gap-3">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => setActiveComponent('clinica')}>
          <img src={logo} alt="Logo" className="h-11 w-auto rounded-lg shadow-sm border border-slate-200 bg-white" />
          <div className="flex flex-col min-w-0">
            <span className="text-xs font-medium text-slate-500 uppercase tracking-wide">Redplika</span>
            <span className="text-base font-semibold text-slate-800 truncate">{saludo}</span>
          </div>
        </div>

        <nav className="hidden md:flex items-center gap-2">
          <button
            className="px-4 py-2 text-sm font-medium text-slate-600 hover:text-[#205087] hover:bg-slate-100 rounded-lg transition-colors"
            onClick={() => setActiveComponent('clinica')}
          >
            Clínica
          </button>
          <button
            className="ml-2 px-4 py-2 text-sm font-medium text-white bg-[#205087] hover:bg-[#1a4069] rounded-lg shadow-sm transition-colors"
            onClick={handleLogout}
          >
            Cerrar sesión
          </button>
        </nav>

        {/* Menú móvil */}
        <div className="md:hidden relative">
          <button
            className="p-2 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors"
            onClick={toggleMenu}
            aria-label="Menú"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          {isMenuOpen && (
            <div className="absolute right-0 top-full mt-2 w-48 bg-white rounded-xl shadow-lg border border-slate-200 py-2 z-50">
              <button
                className="w-full text-left px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50"
                onClick={() => { setActiveComponent('clinica'); toggleMenu(); }}
              >
                Clínica
              </button>
              <button
                className="w-full text-left px-4 py-2.5 text-sm font-medium text-[#205087] hover:bg-slate-50"
                onClick={() => { handleLogout(); toggleMenu(); }}
              >
                Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
